export default "__VITE_ASSET__91984017__"